import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);

    const wallThickness = 0.005;
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])
    
    let offset;
    if(params.lean_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const offsetHeight = (params.p_r_s === 1) ? -0.15 : 0;
    const trimOffset = (params.p_b_c_b_l === 'Open') ? 0 : 0.1; 

    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
       
        model.moveTo(params.lean_p_d / 2 - 0.01, 0);
        model.lineTo(params.lean_p_d / 2 - 0.01, sideWallCloseSize + trimOffset - 0.1);
        model.lineTo(params.lean_p_d / 2 + 0.23, sideWallCloseSize + trimOffset - 0.1);
        model.lineTo(params.lean_p_d / 2 + 0.23, 0);
        model.closePath();
        return model;
    }, [, sideWallCloseSize, params.p_b_c_b_l_b, params.add_left_back_lean_porch, params.lean_p_h, params.lean_p_d, offsetHeight, params.p_b_c_b_l, trimOffset])


    /************** cutting hole in wainscot Trim using CSG for Front***************/
    const storageFrontWall = useMemo(() => {
        let wainscot;
        let trim;

        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.lean_p_w - 0.01)))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModelTwo, extrudeSettings(0.22)));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set((params.lean_p_d / 2  - parseInt(params.add_storage)) - 0.03, 3 , (params.lean_p_w) + 0.05)
        meshStorageFrontWainscotModel_Temp.rotation.y = Math.PI
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();
    
        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set((params.lean_p_d / 2  - parseInt(params.add_storage)) + 0.5, 0, ( params.p_w/2 + params.lean_p_w) + 0.05);
        meshFrontStorageDelModel_Temp.rotation.y = Math.PI/-2
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.leftLeanStoragePosition, 0, -0.7 - params.lean_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshTrimModel_Temp = meshTrimModel.clone();
        meshTrimModel_Temp.position.set(-parseInt(params.add_storage) - 0.1 - offset, 0, -0.02)
        meshTrimModel_Temp.updateMatrixWorld();
    
        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);

    
        const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const storageSideWallDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(storageSideWallDelModel_CSG,new THREE.Matrix4());
        const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());

        wainscot = CSGStorageFrontWainscotModel.geometry;
        trim = meshTrimDelModel.geometry;

        return {wainscot, trim}
    }, [params.lean_p_d, params.lean_p_w, params.add_storage, params.p_w, const_var.newDoorsArray, params.lean_p_pos, params.leftLeanStoragePosition, params.p_b_c_b_l, backWallVrTrimModelTwo])

    /****************************************************************/

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_l === 'Open' || typeof(params.p_b_c_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.lean_p_h + 0.15;
            } else {
                tempWallCloseSize = params.lean_p_h;
            }
        } else if (params.p_b_c_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4 * 3;
        } else if (params.p_b_c_b_l === "Half_Close") {
            tempWallCloseSize = params.lean_p_h / 2;
        } else if (params.p_b_c_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.lean_p_h / 4;
        } else if (params.p_b_c_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.lean_p_h - 3 * params.p_b_c_b_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_l, params.lean_p_h, params.p_r_s])
    
    return (
        <group  position={[-(params.p_w / 2 + params.lean_p_w + 0.05 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            <mesh name="storage-wall-trim" geometry={storageFrontWall.trim}>
                <MaterialTrim visibleSection={"leftLean"} />
            </mesh>

            {params.p_w_c_n == true &&
                <mesh name="wainscotTrim" geometry={storageFrontWall.wainscot} position={[-offset, 0, 0]} >
                    <MaterialWainScotTrimNew visibleSection={"leftlean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel